module.exports = __webpack_public_path__ + "static/media/ed-infantil.32b869dc.png";